import { EventTypes } from 'redux-segment';

const initState = {
  currentUser: null
}

// ACTION TYPES
const SIGN_UP = 'SIGN_UP'
const SIGN_IN = 'SIGN_IN'
const SIGN_OUT = 'SIGN_OUT'
const SAVE_USER_TO_STATE = 'SAVE_USER_TO_STATE'

// ACTIONS
export const signUp = (user) => ({
  type: SIGN_UP,
  payload: user,
  meta: {
    analytics: {
      eventType: EventTypes.identify,
      eventPayload: {
        event: SIGN_UP,
        userId: user.uid,
        traits: {
          email: user.email
        },
      },
    },
  },
})
export const signIn = (user) => ({
  type: SIGN_IN,
  payload: user,
  meta: {
    analytics: {
      eventType: EventTypes.identify,
      eventPayload: {
        event: SIGN_UP,
        userId: user.uid,
        traits: {
          email: user.email
        },
      },
    },
  },
})
export const signOut = () => ({
  type: SIGN_OUT,
  payload: null,
  meta: {
    analytics: {
      eventType: EventTypes.reset
    },
  },
})
export const saveUserToState = (user) => ({
  type: SAVE_USER_TO_STATE,
  payload: user,
})

// REDUCER
export default (state = initState, action) => {
  switch (action.type) {
    case SIGN_UP:
    case SIGN_IN:
    case SIGN_OUT:
    case SAVE_USER_TO_STATE:
      return {...state, currentUser: action.payload}
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js